import React, { useState } from 'react';
import axios from 'axios';
import { FormikAutocompletePx } from '@webapps/reactjs-tech-components';
import { debounce } from '@material-ui/core';
import { useToast } from '@webapps/reactjs-tech-components';


const CitySearchDropdown = ({ formik, name = "cities", label = "Ville", className, ...props }) => {
  const [cityOptions, setCityOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { addToast } = useToast();

  const fetchCities = async (input) => {
    if (input.length < 3) {
      setCityOptions([]);
      return;
    }

    try {
      setLoading(true);
      const response = await axios.get(
        `https://geo.api.gouv.fr/communes?nom=${input}&fields=nom,population&boost=population&limit=20`
      );

      setCityOptions(response?.data.map((city) => ({ label: city.nom, id: city.code })));
    } catch (error) {
      console.error("Erreur lors de la récupération des villes :", error);
      addToast({
        status: 'error',
        message: "Le service de récupération des villes est momentanément indisponible.",
      });
      setCityOptions([]);
    } finally {
      setLoading(false);
    }
  };

  const debounceFetchCities = debounce(fetchCities, 300); // Attendre 300ms avant d'appeler fetchCities

  return (
    <FormikAutocompletePx
      formik={formik}
      fullWidth
      getOptionLabel={(option) => option.label || ''} // Afficher le nom de la ville
      borderRadius={6}
      label={label}
      name={name}
      options={cityOptions}
      pathValue="label" // Utilisation de l'ID unique pour lier une option
      value={
        cityOptions.find((city) => city.label === formik.values[name]) || formik.values[name] || null
      }
      onInputChange={(event, value) => debounceFetchCities(value)}
      isLoading={loading} // Passer l'indicateur de chargement
      className={className}
      {...props}
    />
  );
};

export default CitySearchDropdown;
